import {
    SET_LOGIN_ERROR,
    SET_PHONE_NUMBER,
    TIMER_START,
    TIMER_TICK,
    VERIFICATION_START,
    VERIFICATION_SUCCESS
} from "../Actions/Types";

import { service as AuthService} from "../../Services/Core/AuthService";
import { service as TwoFactorAuthService} from "../../Services/TwoFactorAuthService";
import { service as ForgotPasswordService} from "../../Services/ForgotPasswordService";

export const login = () => async (dispatch, getState) => {
    const { loginState, userState } = getState();
    
    try {
        const x = await AuthService.Login(loginState.fields.email, loginState.fields.password, true);
        if (x.success) {
            
        } else {
            dispatch(handleError('login', x.message || 'invalid login'));
        }
    } catch (x) {
        if (x.data && x.data.message) {
            dispatch(handleError('login', x.data.message));
        } else {
            dispatch(handleError('login', x.message || 'invalid login'));
        }
    }
    
};

let timerInterval = null;

export const ensureCodeTimerIsActive = (time = null) => (dispatch, getState) => {
    const { loginState } = getState();
    
    // make sure we don't already have a timer
    clearInterval(timerInterval);
    
    timerInterval = setInterval(() => {
        // Refreshed timer after dispatching TIMER_START
        const { timer } = loginState ?? {};
        
        if (timer > 0) {
            dispatch({type: TIMER_TICK});
        } else {
            clearInterval(timerInterval);
        }
    }, 1000);
    
}

export const resetCodeTimer = (time = null) => (dispatch, getState) => {
    dispatch({type: TIMER_START, time});
    dispatch(ensureCodeTimerIsActive());
    
    // Clear any existing errors
    dispatch(handleError('verify', ''));
}

export const sendCode = () => (dispatch, getState) => {
    const { loginState } = getState();

    dispatch(resetCodeTimer());

    TwoFactorAuthService.SendVerificationCode({
        mobileNumber: loginState.fields.mobileNumber,
    })
        .then(x => {

            if (loginState.displayPhoneNumberForm) {
                const number = loginState.fields.mobileNumber;
                const maskedNumber = loginState.fields.maskedNumber || '(***) ***-' + number.substring(number.length - 4, number.length);

                dispatch({type: SET_PHONE_NUMBER, maskedNumber});
            }
        })
        .catch(x => {
            dispatch(handleError('sendCode', x.message));
        });
};

export const verifyCode = (callback) => (dispatch, getState) => {
    const { loginState } = getState();

    dispatch(handleError('verify', ''));

    TwoFactorAuthService.VerifyCode({
        code: loginState.fields.code,
        mobileNumber: loginState.fields.mobileNumber,
        rememberMe: loginState.fields.rememberMe,
    })
        .then(x => {
            dispatch({type: VERIFICATION_SUCCESS});
            callback?.();
        })
        .catch(x => {
            console.log(x);
            dispatch(handleError('verify', x.message));
        });
};

export const resetPassword = (key, password) => async (dispatch, getState) => {
    let errorMessage = null;
    try {
        const x = await ForgotPasswordService.ResetPassword(key, password);
        if (x.status === 200) {
            return true;
        }
        errorMessage = x?.message ?? "Unexpected server response.";
    } catch (error) {
        console.log(error);
        errorMessage = error?.data?.message ?? error?.message ?? "unknown error";
        if(error?.data?.sessionTimeout) {
            errorMessage = "This password reset link has expired. Please request a new password reset e-mail.";
        }
    }
    dispatch(handleError('reset', errorMessage));
    return false;
}

const handleError = (field, errorMessage) => (dispatch) => {
    dispatch({type: SET_LOGIN_ERROR, field, errorMessage});
};
